// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3shlN","importantInfo":"styles_importantInfo__nO9NU"};